/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TermsOfServiceLegalbirdFinancingPageMeta from "./TermsOfServiceLegalbirdFinancingPageMeta";
import Container from "@/src/components/Container/Container";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import TermsOfServiceLegalbirdFinancing from "@/src/components/TermsOfService/TermsOfServiceLegalbirdFinancing/TermsOfServiceLegalbirdFinancing";

const TermsOfServiceLegalbirdFinancingPage = () => {
  return (
    <LayoutPublicRoutes>
      <TermsOfServiceLegalbirdFinancingPageMeta />
      <Container showVerticalPadding={false}>
        <TermsOfServiceLegalbirdFinancing />
      </Container>
    </LayoutPublicRoutes>
  );
};

export default TermsOfServiceLegalbirdFinancingPage;
